import * as React from 'react'
import getDisplayName from 'react-display-name'
import hoistNonReactStatics from 'hoist-non-react-statics'

interface IWrappedComponentProps {
  isMounted?: boolean
  runIfMounted?: (fn: () => void) => void
}

export default function isMounted<TProps extends IWrappedComponentProps>(
  WrappedComponent: React.ComponentType<TProps>
): React.ComponentType<Omit<TProps, 'isMounted' | 'runIfMounted'>> {
  class IsMounted extends React.Component<Omit<TProps, 'isMounted' | 'runIfMounted'>> {
    mounted = false

    static displayName = `isMounted(${getDisplayName(WrappedComponent)})`

    componentDidMount() {
      this.mounted = true
    }

    componentWillUnmount() {
      this.mounted = false
    }

    runIfMounted = (fn: () => void) => window.requestAnimationFrame(() => this.mounted && fn())

    render() {
      return <WrappedComponent {...(this.props as any)} isMounted={this.mounted} runIfMounted={this.runIfMounted} />
    }
  }

  return hoistNonReactStatics(IsMounted, WrappedComponent)
}
